export default "__VITE_ASSET__Dzfghxi7__"